// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"57560a6b2d04f5190e12","655":"269f851f93949b5f1751"}[chunkId] + ".js";
};